import { Injectable, EventEmitter } from '@angular/core';
import { Configuration } from '../configurations/shared.config';
import { AuthenticationService } from './authentication.service';

declare var $;

@Injectable()
export class SignalRNotificationService {

    private notificationProxy: any; // private notificationProxy: HubProxy;

    private PanicProxy: any;
    // private WorkOrderProxy: any;
    // private NormaOrderProxy: any;
    private DeviceLogProxy: any;

    private proxyName: string = 'notificationHub';
    private PanicProxyName: string = 'PanicHub';
    // private WorkOrderProxyName: string = 'WorkOrderHub';
    // private NormaOrderProxyName: string = 'NormaOrderHub';
    private DeviceLogProxyName: string = 'DeviceLogHub';


    private connection;
    private panicConnection;
    // private workOrderConnection;
    // private normaOrderConnection;
    private deviceLogConnection;

    public notificationReceived: EventEmitter<any>;
    public notificationMarkedAsRead: EventEmitter<any>;

    public PanicReceived: EventEmitter<any>;
    public PanicResolved: EventEmitter<any>;

    public connectionEstablished: EventEmitter<Boolean>;
    public connectionStateChanged: EventEmitter<any>;

    // public workOrderChanged: EventEmitter<any>;
    // public workOrderCreated: EventEmitter<any>;
    // public workOrderDetailsChanged: EventEmitter<any>;

    // public normaOrderCreated: EventEmitter<any>;
    // public normaOrderChanged: EventEmitter<any>;

    public DeviceLogReceived: EventEmitter<any>;

    public connectionExists: Boolean;

    constructor(private auth: AuthenticationService) {

        this.connectionEstablished = new EventEmitter<Boolean>();
        this.connectionStateChanged = new EventEmitter<any>();

        this.notificationReceived = new EventEmitter<any>();
        this.notificationMarkedAsRead = new EventEmitter<any>();
        this.PanicReceived = new EventEmitter<any>();
        this.PanicResolved = new EventEmitter<any>();
        // this.workOrderChanged = new EventEmitter<any>();
        // this.workOrderCreated = new EventEmitter<any>();

        // this.normaOrderCreated = new EventEmitter<any>();
        // this.normaOrderChanged = new EventEmitter<any>();
        // this.workOrderDetailsChanged = new EventEmitter<any>();
        this.DeviceLogReceived = new EventEmitter<any>();
        this.connectionExists = false;

        this.connection = $.hubConnection(Configuration.urls.signalrEndpoint);
        this.panicConnection = $.hubConnection(Configuration.urls.signalrEndpoint);
        // this.workOrderConnection = $.hubConnection(Configuration.urls.signalrEndpoint);
        // this.normaOrderConnection = $.hubConnection(Configuration.urls.signalrEndpoint);
        this.deviceLogConnection = $.hubConnection(Configuration.urls.signalrEndpoint);

        var currentUser: any = this.auth.getCurrentUser();
     
        this.notificationProxy = this.connection.createHubProxy(this.proxyName);
        this.PanicProxy = this.panicConnection.createHubProxy(this.PanicProxyName);
        // this.WorkOrderProxy = this.workOrderConnection.createHubProxy(this.WorkOrderProxyName);
        // this.NormaOrderProxy = this.workOrderConnection.createHubProxy(this.NormaOrderProxyName);
        this.DeviceLogProxy = this.deviceLogConnection.createHubProxy(this.DeviceLogProxyName);


        this.connection.stateChanged((event) => {
  
            this.connectionStateChanged.emit(event);

            if (event.newState == ConnectionState.disconnected) {
                this.startConnection();
            }
        });

        this.panicConnection.stateChanged((event) => {
            this.connectionStateChanged.emit(event);

            if (event.newState == ConnectionState.disconnected) {
                this.startPanicConnection();
            }
        });

        // this.workOrderConnection.stateChanged((event) => {
        //   //  //debugger;
        //     this.connectionStateChanged.emit(event);
        //     if (event.newState == ConnectionState.disconnected) {
        //         this.startworkOrderConnection();
        //     }
        // });

        // this.normaOrderConnection.stateChanged((event) => {
        //     //debugger;
        //     this.connectionStateChanged.emit(event);

        //     if (event.newState == ConnectionState.disconnected) {
        //         this.startnormaOrderConnection();
        //     }
        // });

        this.deviceLogConnection.stateChanged((event) => {
            this.connectionStateChanged.emit(event);

            if (event.newState == ConnectionState.disconnected) {
                this.startDeviceLogConnection();
            }
        });



        auth.validUser();

        this.registerOnServerEvents();
        this.startConnection();
        this.startPanicConnection();
        //this.startworkOrderConnection();
        this.startDeviceLogConnection();

    }



    private startConnection(): void {
        this.connection.qs = 'StaffId=' + this.auth.staffId;
        this.connection.start().done((data) => {

            this.connectionEstablished.emit(true);
            this.connectionExists = true;

        }).fail((error) => {
           
            this.connectionEstablished.emit(false);
            setTimeout(() => this.startConnection(), 1000);
            return;

            });
    }

    private startPanicConnection(): void {
        var currentUser: any = this.auth.getCurrentUser();
        if (currentUser) {
            this.panicConnection.qs = 'StaffId=' + currentUser.userName;
            this.panicConnection.start().done((data) => {

                this.connectionEstablished.emit(true);
                this.connectionExists = true;

            }).fail((error) => {

                this.connectionEstablished.emit(false);
                setTimeout(() => this.startConnection(), 1000);
                return;

            });

        }
    }

    // private startworkOrderConnection(): void {
    //   //  //debugger;
    //     var currentUser: any = this.auth.getCurrentUser();
    //     if (currentUser) {
    //         this.workOrderConnection.qs = 'Username=' + currentUser.userName;
    //         this.workOrderConnection.start().done((data) => {
    //             this.connectionEstablished.emit(true);
    //             this.connectionExists = true;

    //         }).fail((error) => {
    //             this.connectionEstablished.emit(false);
    //             setTimeout(() => this.startworkOrderConnection(), 1000);
    //             return;

    //         });

    //     }
    // }

    // private startnormaOrderConnection(): void {
    // //    //debugger;
    //     var currentUser: any = this.auth.getCurrentUser();
    //     if (currentUser) {
    //         this.workOrderConnection.qs = 'Username=' + currentUser.userName;
    //         this.workOrderConnection.start().done((data) => {
    //             this.connectionEstablished.emit(true);
    //             this.connectionExists = true;

    //         }).fail((error) => {
    //             this.connectionEstablished.emit(false);
    //             setTimeout(() => this.startnormaOrderConnection(), 1000);
    //             return;

    //         });

    //     }
    // }

    private startDeviceLogConnection(): void {
        var currentUser: any = this.auth.getCurrentUser();
        if (currentUser) {
            this.deviceLogConnection.qs = 'Username=' + currentUser.userName;
            this.deviceLogConnection.start().done((data) => {
                this.connectionEstablished.emit(true);
                this.connectionExists = true;

            }).fail((error) => {
                this.connectionEstablished.emit(false);
                setTimeout(() => this.startDeviceLogConnection(), 1000);
                return;

            });

        }
    }


    private registerOnServerEvents(): void {

        this.notificationProxy.on('receiveNotification', (data: any) => {
            this.notificationReceived.emit(data);
        });
        this.notificationProxy.on('markNotificationAsRead', (id: any) => {
            this.notificationMarkedAsRead.emit(id);
        });

        this.PanicProxy.on('receivePainc', (data: any) => {
            this.PanicReceived.emit(data);
        });
        this.PanicProxy.on('markPanicAsResolved', (data: any) => {
            this.PanicResolved.emit(data);
        });

        // this.WorkOrderProxy.on('receiveWorkOrderStatus', (data: any) => {
        //   //  //debugger;
        //     this.workOrderChanged.emit(data);
        // });

        // this.WorkOrderProxy.on('receiveWorkOrderDetailsChanges', (data: any) => {
        //     //debugger;
        //     this.workOrderDetailsChanged.emit(data)
        // });

        // this.WorkOrderProxy.on('receiveWorkOrderCreated', (data: any) => {
        //     //debugger;
        //     this.workOrderCreated.emit(data)
        // });

        // this.NormaOrderProxy.on('receiveNormaOrderStatus', (data: any) => {
        //     //debugger;
        //     this.normaOrderChanged.emit(data);
        // });

        // this.NormaOrderProxy.on('receiveNormaOrderCreated', (data: any) => {
        //     //debugger;
        //     this.normaOrderCreated.emit(data)
        // });
        this.DeviceLogProxy.on('receiveDeviceState', (data: any) => {
            this.DeviceLogReceived.emit(data);
        });

    } 
}

export enum ConnectionState {

    connecting = 0,
    connected = 1,
    reconnecting = 2,
    disconnected = 4
}



// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/services/signalR-notification.service.ts